import React, { useEffect, useState, useRef } from 'react';
import { useParams, Link } from 'react-router-dom';
import html2pdf from 'html2pdf.js';
import './BillPage.css';
import logo from './logobill.png'; // adjust path if needed

function BillPage() {
  const { orderId } = useParams();
  const [order, setOrder] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const billRef = useRef();
  const token = localStorage.getItem('adminToken');

  useEffect(() => {
    const fetchOrder = async () => {
      try {
        if (!token) throw new Error('Unauthorized: Admin token missing');
        const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/admin/orders/${orderId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) {
          const errData = await res.json();
          throw new Error(errData.message || 'Failed to fetch order');
        }
        const data = await res.json();
        setOrder(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchOrder();
  }, [orderId, token]);

  const handleDownloadPdf = () => {
    const element = billRef.current;
    const opt = {
      margin: 0,
      filename: `Bill_${orderId}.pdf`,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
      pagebreak: { mode: ['avoid-all'] },
    };
    html2pdf().set(opt).from(element).save();
  };

  if (loading) return <div className="container mt-5">Loading bill...</div>;
  if (error) return <div className="container mt-5 alert alert-danger">{error}</div>;
  if (!order) return null;

  const grandTotal = order.totalPrice;
  const orderDate = new Date(order.createdAt).toLocaleString();

  return (
    <div className="container my-5">
      <h2 className="text-center text-success mb-4">🧾 Printable Bill</h2>

      <div ref={billRef} className="bill-box">
        <div className="bill-header">
          <img src={logo} alt="Logo" className="bill-logo" />
          <div className="bill-title">Fastest Coder Innovations Pvt. Ltd.</div>

          <div className="left-text"><strong>Reg. Office:</strong> Road No.5, Mithila Colony, North Patel Nagar, Patna, Bihar - 800024</div>
          <div className="left-text"><strong>Customer care:</strong> +91 70797 70897</div>
          <div className="left-text"><strong>CIN:</strong> U62099BR2025PTC073817</div>

          <div className="bill-thankyou full-line">********************************</div>
          <div className="bill-thankyou my-0">THANK YOU</div>
          <div className="bill-thankyou full-line">********************************</div>

          <div><strong>binzal</strong></div>
          <div className="left-text"><strong>Address:</strong> Karnapur, Jhanjharpur, Madhubani - 847204</div>
          <div className="left-text"><strong>Phone:</strong> +91 70797 70897</div>
          <div className="left-text"><strong>Website:</strong> www.binzal.com</div>
          <div className="left-text"><strong>Email:</strong> support@binzal.com</div>
        </div>
   <div className="bill-line">---------------------------------</div>
        <div><strong>Order ID:</strong> {order.orderId}</div>
        <div><strong>Date:</strong> {orderDate}</div>

         <div className="bill-line">---------------------------------</div>
        <div><strong>Delivery To:</strong></div>
        <div><strong>Name:</strong> {order.deliveryDetails?.name}</div>
        <div><strong>Locality:</strong> {order.deliveryDetails?.address}</div>
        <div><strong>District:</strong> {order.deliveryDetails?.city}</div>
        <div><strong>Pincode:</strong> {order.deliveryDetails?.pincode}</div>
        <div><strong>Phone:</strong> {order.deliveryDetails?.mobile}</div>

     <div className="bill-line">---------------------------------</div>
        <div><strong>Items:</strong></div>
        {order.items.map((item, index) => (
          <div key={index}>
            {item.name} {item.weight} x {item.quantity} = ₹{(item.price * item.quantity).toFixed(2)}
          </div>
        ))}

           <div className="bill-line">---------------------------------</div>
        <div>Subtotal: ₹ {order.totalPrice.toFixed(2)}</div>
        <div>Delivery Charges: ₹00</div>
        <div><strong>Grand Total: ₹{grandTotal.toFixed(2)}</strong></div>

        <div className="bill-line">---------------------------------</div>
        <div className="text-center mt-2 mb-2">Thanks for choosing binzal. </div>
        <div className="bill-thankyou mt-1"> Fast. Fresh. binzal </div>
      </div>

      <div className="text-center mt-4">
        <button className="btn btn-success" onClick={handleDownloadPdf}>⬇ Download PDF</button>
      </div>

      <div className="text-center mt-3">
        <Link to="/orders" className="btn btn-secondary">← Back to Orders</Link>
      </div>
    </div>
  );
}

export default BillPage;
